import React from 'react';

type BackButtonProps = { handleClick?: () => void };

const BackButton = ({ handleClick }: BackButtonProps) => {
	return (
		<div className="vtex-login-2-x-backButton backButton" onClick={() => handleClick && handleClick()}>
			<button
				className="vtex-button bw1 ba fw5 v-mid relative pa0 lh-solid br2 min-h-small t-action--small bg-transparent b--transparent c-action-primary hover-b--transparent hover-bg-action-secondary hover-b--action-secondary pointer "
				type="button"
			>
				<div
					className="vtex-button__label flex items-center justify-center h-100 ph5 "
					style={{ paddingTop: '0.25em', paddingBottom: '0.32em' }}
				>
					<span className="flex items-center nr1">
						<div className="mr2 nl2 flex items-center">
							<svg
								fill="none"
								width="10"
								height="10"
								viewBox="0 0 16 11"
								className=" vtex-login-2-x-arrowBackIcon arrowBackIcon"
								xmlns="http://www.w3.org/2000/svg"
							>
								<use href="#hpa-arrow-back"></use>
							</svg>
						</div>
						<div>
							<span className="t-small ml2">Voltar</span>
						</div>
					</span>
				</div>
			</button>
		</div>
	);
};

export default BackButton;
